import { fieldNames } from '../fields';
import { EditorState } from 'draft-js';

export const dataModel = {
    component: String(),
    id: String(),
    editorState: Object(),
};

export const defaults = {
    component: fieldNames.richContent,
    editorState: EditorState.createEmpty()
};
